<template>
  <spinner-container :loading="loading">
    <back-btn />
    <v-row justify="center">
      <v-col cols="12" md="6">
        <region-form :region="region" @emitRegionData="UpdateRegion" />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import RegionForm from "@/components/region/RegionForm";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    RegionForm,
    SpinnerContainer,
    BackBtn,
  },
  data: () => ({}),
  computed: {
    ...mapState("Region", ["region"]),
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    UpdateRegion(payload) {
      this.$store.dispatch("Region/updateRegion", payload).then(() => {
        this.$router.push({ name: "region" });
      });
    },
  },
  created() {
    this.$store.dispatch("Region/getRegion", this.$route.params.id);
  },
};
</script>
